module.exports = __webpack_public_path__ + "static/media/bejaia.3c7c6de1.jpg";